import * as React from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { compareAsc, isSameDay } from '../../shared/dateFns';
import { State } from '../state';
import Event from './Event';

interface IProps {
    date: Date;
}

const EMPTY_LIST: number[] = [];

const idsSelector = createSelector(
    (state: State, _: Date) => state.calendar.events.ids,
    (state: State, _: Date) => state.calendar.events.dict,
    (_: State, date: Date) => date,
    (ids, dict, date) => {
        if (date == null) {
            return EMPTY_LIST;
        }
        ids = ids.filter(id => isSameDay(dict[id].start, date));
        return ids.sort(compareAsc);
    },
);

function EventList({ date }: IProps): JSX.Element {
    const ids = useSelector((state: State) => idsSelector(state, date));
    return <div>
        {ids.map(id => <Event key={id} id={id} />)}
    </div>;
}

export default React.memo(EventList);
